import { useEffect, useState } from 'react';
import LeaveBoard from './filter-bar-options/LeaveBoard';
import FollowBoard from './filter-bar-options/FollowBoard';
import { useFetcher } from '@remix-run/react';
import type { DesignBoardWithDetailedPinsFragment } from 'generated/graphql';

interface SubscribeToBoardProps {
    isFollower: boolean;
    isCollaborator: boolean;
    board: DesignBoardWithDetailedPinsFragment;
}

const SubscribeToBoard = ({
    isFollower,
    isCollaborator,
    board,
}: SubscribeToBoardProps) => {
    const fetcher = useFetcher<never>();

    const [following, setFollowing] = useState(isFollower);

    const idString = board.ID.toString();
    const data = { designBoardId: idString, boardTitle: board.Title };

    const handleFollow = () => {
        setFollowing(true);
        fetcher.submit(data, {
            method: 'post',
            action: '/remix-api/design-board/follow-design-board',
        });
    };

    const handleLeave = () => {
        setFollowing(false);
        fetcher.submit(data, {
            method: 'post',
            action: '/remix-api/design-board/leave-design-board',
        });
    };

    useEffect(() => {
        setFollowing(isFollower);
    }, [isFollower]);

    const followAction = !isCollaborator ? (
        <FollowBoard handleFollow={handleFollow} board={board} />
    ) : null;

    return following ? (
        <LeaveBoard
            handleLeave={handleLeave}
            designBoardId={board.ID}
            boardTitle={board.Title}
        />
    ) : (
        followAction
    );
};

export default SubscribeToBoard;
